module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/global/global-update/global-update.component.html
// module id = ./client/app/global/global-update/global-update.component.html
// module chunks = main